import { OktaContext } from "@okta/okta-react";
import type { AuthState, OktaAuth } from "@okta/okta-auth-js";
import type { ReactNode } from "react";

const ADMIN_GROUP = import.meta.env.VITE_OKTA_ADMIN_GROUP || "jump-pipelines-admins";
export const PREVIEW_EMAIL = "preview@jump.com";

// Only the claims the shell reads: AuthGate checks groups, TopBar shows the email.
const authState = {
  isAuthenticated: true,
  accessToken: { claims: { groups: [ADMIN_GROUP] } },
  idToken: { claims: { email: PREVIEW_EMAIL } },
} as unknown as AuthState;

const oktaAuth = {
  signOut: async () => { window.location.assign("/"); },
  signInWithRedirect: async () => {},
  handleLoginRedirect: async () => {},
} as unknown as OktaAuth;

/**
 * Stands in for Okta's `<Security>` under `pnpm preview`.
 *
 * Every component calling `useOktaAuth()` sees a signed-in admin, so the whole
 * shell can be driven with no Okta tenant. The fixed banner is not decoration:
 * it is what keeps a preview screenshot from being read as production.
 */
export function PreviewSecurity({ children }: { children: ReactNode }) {
  return (
    <OktaContext.Provider value={{ oktaAuth, authState }}>
      {children}
      <div className="preview-banner" role="status">Local preview · sample data · nothing here reaches HubSpot or Jump</div>
    </OktaContext.Provider>
  );
}
